<div [class]="customClass ? 'create-page-container' : 'container'">
    <h6 class="sub-title" [class.show]="value && !customClass">
        {{ subTitle | translate }}
    </h6>
    <textarea
        data-cy="description-text-area"
        [class]="customClass ? customClass : 'textarea'"
        [placeholder]="[!textAreaFocus ? (placeholder | translate) : '']"
        (keypress)="onTextAreaKeyPress($event)"
        (input)="onTextAreaChange()"
        (focus)="onTextAreaFocus()"
        (blur)="onTextAreaBlur()"
        [(ngModel)]="value"
        [maxlength]="maxlength"
        #inputArea
    >
    </textarea>
</div>
